export default function formatNomes(str) {
  let palavras = str.split(" ");
  for (let i = 0; i < palavras.length; i++) {
    palavras[i] =
      palavras[i].charAt(0).toUpperCase() + palavras[i].slice(1).toLowerCase();
  }
  return palavras.join(" ");
}
